export default __webpack_public_path__ + "static/media/emoji.0282b400.svg";